export default class SelectFloatingPanel {
  constructor({ root, panel, frame }) {
    this.root = root
    this.panel = panel
    this.frame = frame
    this.floating = false
  }

  position() {
    this.floating = Boolean(this.clippingAncestor)
    if (!this.floating) return

    // Move out of the cropped layout before measuring. Otherwise the scrollbar introduced by
    // the panel can change the width of the control that anchors it.
    Object.assign(this.panel.style, {
      position: "fixed", left: "0px", top: "0px", right: "auto",
    })

    const rect = this.frame.getBoundingClientRect()
    Object.assign(this.panel.style, {
      left: `${rect.left}px`,
      top: `${rect.bottom}px`,
      width: `${rect.width}px`,
    })
  }

  reset() {
    this.floating = false
    this.panel.removeAttribute("style")
  }

  shouldCloseAfter(event) {
    if (!this.floating) return false
    if (event.target instanceof Node && this.panel.contains(event.target)) return false

    return true
  }

  // `overflow-x: auto` also makes the other axis non-visible, so either axis can crop a panel.
  get clippingAncestor() {
    let node = this.root.parentElement

    while (node && node !== document.body) {
      const style = getComputedStyle(node)
      if (style.overflowX !== "visible" || style.overflowY !== "visible") return node

      node = node.parentElement
    }

    return null
  }
}
